function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { kebabCase } from 'lodash';
import Icon from '../../common/containers/icon';
const PickerTextControls = ({
  editing,
  text,
  onChange,
  onSave,
  hoverStyle: _hoverStyle = {},
  onEdit,
  autoFocus: _autoFocus = false,
  isDisabled,
  onDisableToggle
}) => {
  const ref = useRef();
  useLayoutEffect(() => {
    if (_autoFocus && ref) {
      ref.current.scrollIntoView();
    }
  }, [_autoFocus]);
  return /*#__PURE__*/React.createElement("span", {
    ref: ref,
    style: {
      verticalAlign: 'bottom',
      lineHeight: '28px'
    }
  }, editing ? /*#__PURE__*/React.createElement("input", {
    className: `t-ptc-${kebabCase(text)}`,
    style: {
      height: 28
    },
    value: text
    /* eslint-disable-next-line jsx-a11y/no-autofocus */,
    autoFocus: _autoFocus,
    onKeyDown: e => {
      if (e.key === 'Enter') {
        onSave();
      }
    },
    onChange: onChange
  }) : /*#__PURE__*/React.createElement("span", {
    style: _objectSpread(_objectSpread({}, _hoverStyle), {}, {
      opacity: isDisabled ? 0.5 : 1
    }),
    className: `t-tn-row-${kebabCase(text)}`
  }, text), /*#__PURE__*/React.createElement("span", {
    style: {
      float: 'right'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: editing ? onSave : onEdit,
    className: `t-tn-button-save-${kebabCase(text)}`
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: editing ? 'save' : 'pencil-alt'
  }), " ", editing ? 'Done' : 'Edit'), /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: () => onDisableToggle(!isDisabled),
    className: `t-tn-button-enable-${kebabCase(text)}`,
    disabled: editing,
    style: {
      marginLeft: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: isDisabled ? 'check' : 'times'
  }), " ", isDisabled ? 'Enable' : 'Disable')));
};
PickerTextControls.propTypes = {
  editing: PropTypes.bool.isRequired,
  hoverStyle: PropTypes.shape({}),
  text: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool,
  isDisabled: PropTypes.number.isRequired,
  onDisableToggle: PropTypes.func.isRequired
};
export default PickerTextControls;